import StudentPanelsConfig from '../../student-container/student-panels.config';

const SupportsPanelConfig = {
  title: StudentPanelsConfig.ASSIGNED_SUPPORTS.human,
  paths: [
    'support.schedule',
    'support.schedule.startsOn',
    'support.schedule.endsOn',
    'support.activityLead',
    'support.activityLead.firstName',
    'support.activityLead.lastName',
    'support.location',
    'support.category',
    'support.name',
  ],
};

export default SupportsPanelConfig;
